import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, first, switchMap, tap } from 'rxjs';
import { consumeReturnUrl } from 'src/app/common/returnUrlUtils';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  constructor(
    private readonly _auth: AuthService,
    private readonly _logger: LoggerService,
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    const organization = this._route?.snapshot?.queryParamMap?.get('organization') ?? null;
    const connection = this._route?.snapshot?.queryParamMap?.get('connection') ?? null;
    const invitation = this._route?.snapshot?.queryParamMap?.get('invitation') ?? null;

    if (organization && invitation) {
      this._logger.info(`A user from zenity account id ` + `${organization} is trying to ` + `accept invitation`);
      this._loginWithInvitation(organization, invitation);
      return;
    }

    if (organization && connection) {
      this._auth.loginWithRedirect({
        authorizationParams: {
          organization,
          connection,
        },
      });
      return;
    }

    this._auth.isLoading$
      .pipe(
        filter((isLoading) => !isLoading),
        first(),
        switchMap(() => this._auth.isAuthenticated$.pipe(first())),
        tap((isAuthenticated: boolean) => {
          const returnUrl = consumeReturnUrl();

          if (organization) {
            if (!isAuthenticated) {
              this._auth.loginWithRedirect({
                appState: returnUrl ? { target: returnUrl } : undefined,
              });
            } else {
              this._router.navigateByUrl(returnUrl || '/app');
            }
          } else if (!isAuthenticated) {
            this._auth.loginWithRedirect({
              appState: returnUrl ? { target: returnUrl } : undefined,
            });
          } else {
            this._router.navigateByUrl(returnUrl || '/app');
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }

  private _loginWithInvitation(organization: string, invitation: string): void {
    this._auth.loginWithRedirect({
      authorizationParams: {
        organization,
        invitation,
        prompt: 'login',
      },
    });
  }
}
